import { ajax as request } from '@blade/common';
/**
 * @description: 获取列表
 * @param {type}
 * @return {type}
 */
export const recordList = (dateEnd, dateStart, keyWord, recordType, sort, size, page, alertType) => request({
    url: '/api/crowd-record-management/api/v1/search/control/records',
    method: 'POST',
    data: {
        dateEnd,
        dateStart,
        keyWord,
        recordType,
        sort,
        size,
        page,
        alertType
    }
});
// export const statisticsList = (dateEnd: string, dateStart: string, deviceId: number, direction: number, timeIntervalType: string, size: number | 10, page: number | 1) =>
//     request({
//         url: '/sensexplorer-records-management/api/v1/search/control/statistics/devices',
//         method: 'POST',
//         data: {
//             dateEnd,
//             dateStart,
//             deviceId,
//             direction,
//             timeIntervalType,
//             size,
//             page
//         }
//     })
export const statisticsList = (data) => request({
    url: '/api/crowd-record-management/api/v1/search/control/statistics/devices',
    method: 'POST',
    data
});
/**
 * @description: 获取人群统计对应得折线图数据
 * @param {type}
 * @return {type}
 */
export const devicesChart = (id, data) => request({
    url: '/api/crowd-record-management/api/v1/search/control/statistics/devices/detail/' + id,
    method: 'POST',
    data
});
export const faceCenterList = (data) => request({
    url: '/api/crowd-record-management/api/v1/search/control/records',
    method: 'POST',
    data
});
/**
 * @description: 导出csv
 * @param {type}
 * @return {type}
 */
export const exportTarget = (param, taskType) => request({
    url: '/api/sensexplorer-target-export-service/api/v1/batchTask/export',
    method: 'POST',
    data: {
        param,
        taskType
    }
});
export const postFixTool = (deviceId, ignorInfo) => request({
    url: '/api/task-management/api/device/config/falseAlertEliminate',
    method: 'POST',
    data: {
        deviceId,
        ignorInfo
    }
});
export const getFixTool = (deviceId) => request({
    url: `/api/task-management/api/device/config/queryFalseAlertArea/${deviceId}`,
    method: 'GET'
});
